// Map domains to LineIcons icon classes
// Reference: node_modules/lineicons/dist/lineicons.css
const domainIconMap: Record<string, string> = {
  // Social
  'twitter.com': 'lni-x',
  'x.com': 'lni-x',
  'instagram.com': 'lni-instagram',
  'facebook.com': 'lni-facebook',
  'tiktok.com': 'lni-tiktok',
  'linkedin.com': 'lni-linkedin',
  'pinterest.com': 'lni-pinterest',
  'snapchat.com': 'lni-snapchat',
  'whatsapp.com': 'lni-whatsapp',

  // Video/Streaming
  'youtube.com': 'lni-youtube',
  'youtu.be': 'lni-youtube',
  'twitch.tv': 'lni-twitch',

  // Music
  'spotify.com': 'lni-spotify',
  'soundcloud.com': 'lni-soundcloud',
  'music.apple.com': 'lni-apple-music',

  // Development
  'github.com': 'lni-github',
  'bitbucket.org': 'lni-bitbucket',
  'stackoverflow.com': 'lni-stackoverflow',

  // Communication
  'discord.com': 'lni-discord',
  'discord.gg': 'lni-discord',
  'slack.com': 'lni-slack',
  'telegram.org': 'lni-telegram',
  't.me': 'lni-telegram',

  // Shopping/Creator
  'booth.pm': 'lni-cart-2',
  'amazon.com': 'lni-amazon',
  'amazon.co.jp': 'lni-amazon',
  'patreon.com': 'lni-patreon',
  'ko-fi.com': 'lni-coffee-cup-2',

  // Creative
  'behance.net': 'lni-behance',
  'dribbble.com': 'lni-dribbble',

  // Gaming
  'steam.com': 'lni-steam',
  'steampowered.com': 'lni-steam',
  'playstation.com': 'lni-playstation',

  // Other
  'medium.com': 'lni-medium',
  'reddit.com': 'lni-reddit',
  'tumblr.com': 'lni-tumblr',
  'wordpress.com': 'lni-wordpress',
};

/**
 * Get icon class for a URL based on its domain
 * @param url The URL to get an icon for
 * @returns The LineIcons class name, or null if no specific icon exists
 */
export function getServiceIcon(url: string): string | null {
  try {
    const hostname = new URL(url).hostname.replace(/^www\./, '');

    // Check exact match first
    if (domainIconMap[hostname]) {
      return domainIconMap[hostname];
    }

    // Check if it's a subdomain of a known domain
    for (const [domain, icon] of Object.entries(domainIconMap)) {
      if (hostname.endsWith('.' + domain) || hostname === domain) {
        return icon;
      }
    }

    return null;
  } catch {
    return null;
  }
}

/**
 * Get icon class for a URL, with fallback to generic link icon
 */
export function getServiceIconOrDefault(url: string): string {
  return getServiceIcon(url) || 'lni-link-2-angular-right';
}
